<template>
  <CCard class="p-4">
    <CCardBody>
      <h1>{{ $t('Reset password') }}</h1>
      <p class="text-muted">{{ $t('Set your new password') }}</p>
      <CForm @submit.prevent="handleSubmit">
        <CInput
          :placeholder="$t('New password')"
          type="password"
          autocomplete="password"
          v-model="password1"
          name="password1"
          required
        >
          <template #prepend-content>
            <CIcon name="cil-lock-locked"/>
          </template>
        </CInput>
        <CInput
          class="my-2"
          :placeholder="$t('Repeat new password')"
          type="password"
          autocomplete="password"
          v-model="password2"
          name="password2"
          required
        >
          <template #prepend-content>
            <CIcon name="cil-lock-locked"/>
          </template>
        </CInput>
        <CButton color="primary" class="px-4" type="submit">
          {{ $t('Change password') }}
        </CButton>
      </CForm>
    </CCardBody>
  </CCard>
</template>

<script>
import { AuthService } from '@/services/auth';

export default {
  name: 'ResetPassword',
  data: function () {
    return {
      password1: '',
      password2: '',
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.password1 || this.password1 !== this.password2) {
        return alert(this.$t('Passwords are not the same'));
      }
      const { res } = await AuthService.resetPassword({
        password: this.password1,
        token: this.$route.params.token,
      });
      if (res.status === 200) {
        alert(this.$t('auth.change_success'));
        return this.$router.push({ name: 'Management Login' });
      }
      alert(this.$t('Something went wrong'));
    },
  },
};
</script>
